
<script setup>
import ValidateEmailLoader from '@/components/ValidateEmailLoader.vue'
</script>

<template>
  <div>
    <validate-email-loader />
  </div>
</template>

